import { DataGrid } from '@turnpike/portal-data-grid';
import { createPortal } from 'react-dom';

import { WidgetPlaceholder } from '../../widgets-elements/WidgetPlaceholder';

import { useTableTotalActionsColumns } from './index.columns';
import Styles from './index.module.scss';

import type { TotalActionsRowItem } from '@/app/types/Dashboard';

import { IosSpinner } from '@/components/Elements/IosSpinner';


interface Props {
	data: TotalActionsRowItem[];
	isLoading?: boolean;
}

export const TableTotalActions = ({ data, isLoading = false }: Props) => {
	const { columns } = useTableTotalActionsColumns();

	return (
		<div className={Styles.container}>
			<DataGrid data={data} columns={columns} isLoading={isLoading} />
		</div>
	);
};

export const LoadingOverlay = ({ container }: { container: HTMLDivElement | null }) => {
	if (!container) return null;

	return createPortal(
		<div
			style={{
				background: 'transparent',
				position: 'absolute',
				left: 0,
				top: 0,
				bottom: 0,
				right: 0,
				zIndex: 10,
				pointerEvents: 'none',

				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<IosSpinner size="3.125rem" duration={1.2} />
		</div>,
		container
	);
};

export const NoDataOverlay = ({ container }: { container: HTMLDivElement | null }) => {
	if (!container) return null;

	return createPortal(
		<div
			style={{
				background: 'transparent',
				position: 'absolute',
				left: 0,
				top: 60,
				bottom: 24,
				right: 0,
				zIndex: 10,
				pointerEvents: 'none',
				boxSizing: 'border-box',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<WidgetPlaceholder state="no-data" />
		</div>,
		container
	);
};
